import HouseKeeperOptions      from "./Entities/HouseKeeperOptions";
import HouseKeeperHTTPService  from "./HTTP/HouseKeeperHTTPService";
import ViewportController      from "@/js/Mailboxes/ViewportController";
import MessagesCollection      from "@/js/Mailboxes/Collections/MessagesCollection";
import MessagesFullSearch      from "@/js/Mailboxes/Entities/Messages/MessagesFullSearch";
import ContentState            from "@/js/Shared/State/ContentState";
import NotificationsController from "@/js/Webmail/Notifications/NotificationsController";

export { HouseKeeperController as default };

/**
* HouseKeeper Controller
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class HouseKeeperController {
  /**
   * Housekeeper HTTP Service
   *
   *  @private
   *
   * @since 7.0.0
   *
   * @type {HouseKeeperHTTPService}
   */
  http_service = new HouseKeeperHTTPService();

  /**
   * Fetches and sets the virtual folder id from the server
   * based on the housekeeper filter params
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {HouseKeeperOptions} options
   * @param {ContentState}       content_state
   *
   * @return {Promise<Boolean>}
   */
  async setVirtualFolder(options, content_state) {
    let date     = new Date();
    date.setDate(date.getDate() - options.period);
    options.criteria                   = new MessagesFullSearch();
    options.criteria.filter_date_start = '1970-01-01';
    options.criteria.filter_date_end   = date.toISOString().slice(0, 10);

    if (options.type === 'seen') {
      options.criteria.flag_read = true;
    }

    if (options.type === 'unseen') {
      options.criteria.flag_read = false;
    }

    if (options.type === 'heavy') {
      options.criteria.filter_size_type  = 'size_larger';
      options.criteria.filter_size_value = options.size * 1024;
    }

    content_state.setLoading();
    let v_response = await ViewportController.fetchMessagesFullSearchCriteria(
      options.criteria, [options.folder.id]
    );

    if (!v_response.folder_id) {
      content_state.setLoadedState(false);
      return false;
    }

    if (await ViewportController.fetchMessages(v_response.folder_id, 99999) === false) {
      content_state.setLoadedState(false);
      return false;
    }

    options.virtual_folder = v_response.folder_id;
    content_state.setLoadedState(true);
    return true;
  }

  /**
   * Calls the server to add an housekeeper job
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {HouseKeeperOptions} options
   * @param {ContentState}       content_state
   *
   * @return {MessagesCollection}
   */
  async addJob(options, content_state) {
    content_state.setLoading();
    let response = await this.http_service.addJob(options);

    NotificationsController.addMessage(response.messages);
    content_state.setLoadedState(response.success);
    return response.success;
  }

  /**
   * Returns virtual folder messages
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {HouseKeeperOptions} options
   *
   * @return {MessagesCollection}
   */
  getVirtualFolderMessages(options) {
    return ViewportController.mailboxes.viewport.get(options.virtual_folder);
  }

  /**
   * Deletes Virtual Folder Messages
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {HouseKeeperOptions} options
   *
   * @return {MessagesCollection}
   */
  deleteVirtualFolder(options) {
    ViewportController.mailboxes.viewport.delete(options.virtual_folder);
  }
}
